import { InstagramOutlined, PinterestOutlined } from "@ant-design/icons";
import { Col, Row } from "antd";
import React from "react";
import { Link } from "react-router-dom";

const Banner = () => {
  return (
    <div
      style={{
        backgroundColor: "#f0f0f0", // Background color
        padding: "20px",
        textAlign: "center",
        marginBottom: "20px",
      }}
    >
      <h2 style={{ color: "burlywood" }}>Follow Me</h2>
      <p style={{ alignContent: "center" }}>
        Stay updated with the latest news and updates.
      </p>
      <Row gutter={16} justify="center">
        <Col>
          <Link
            to="https://www.instagram.com/alamodeimage/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramOutlined style={{ fontSize: "24px", color: "#e4405f" }} />
          </Link>
        </Col>
        <Col>
          <Link
            to="https://www.pinterest.com/alamodeimage/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <PinterestOutlined style={{ fontSize: "24px", color: "#0077b5" }} />
          </Link>
        </Col>
      </Row>
    </div>
  );
};

export default Banner;
